import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { useWorkRequests } from "@/components/experience/use-work-requests";
import { WorkRequestChip } from "@/components/experience/work-request-chip";
import type { QueueRowData } from "./queue-types";

interface QueueTriageControlsProps {
  projectId: string;
  row: QueueRowData;
  canEdit: boolean;
  workflowData?: {
    assignee?: { id: string; displayName?: string | null } | null;
  } | null;
  actions: ReactNode;
}

export function QueueTriageControls({
  projectId,
  row,
  canEdit,
  actions,
}: QueueTriageControlsProps) {
  const requests = useWorkRequests(projectId);
  const openRequest = requests.byCanonical.get(row.id) ?? null;

  return (
    <div className="space-y-3">
      {openRequest && (
        <div className="flex flex-wrap items-center justify-between gap-2.5 rounded-lg border border-border/70 bg-muted/30 px-3 py-2">
          <div className="flex items-center gap-1.5">
            <WorkRequestChip request={openRequest} />
            {canEdit && (
              <Button
                variant="ghost"
                size="sm"
                className="h-6 text-2xs text-muted-foreground hover:text-destructive px-1.5"
                onClick={() => requests.cancel(openRequest.id)}
                disabled={requests.isPending}
              >
                Cancel
              </Button>
            )}
          </div>
        </div>
      )}

      <div className="flex flex-wrap gap-2">{actions}</div>
    </div>
  );
}
